import { render, staticRenderFns } from "./ProductBrowser.vue?vue&type=template&id=1e8afd4c&scoped=true"
import script from "./ProductBrowser.vue?vue&type=script&lang=js"
export * from "./ProductBrowser.vue?vue&type=script&lang=js"
import style0 from "./ProductBrowser.vue?vue&type=style&index=0&id=1e8afd4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8afd4c",
  null
  
)

export default component.exports